import React from "react";
import { ProductWithPrice } from "../../api";

export const ProductContext = React.createContext<{
	productWithPrices: ProductWithPrice[];
}>({
	productWithPrices: [],
});
